module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/banners/app-rc-207a3b113d5e2d5f1fe51fef418b9b9a.svg";